import { CSSProperties, forwardRef, Ref } from 'react';
import './Popover.scoped.scss';

interface Props {
  children: React.ReactNode;
  style?: CSSProperties;
  position?: string;
}

const Popover = forwardRef((props: Props, ref: Ref<HTMLDivElement>) => {
  const { children, style } = props;

  return (
    <div ref={ref} className={'popover-container  '} onClick={e => e.stopPropagation()}>
      <div className={`popover ${props.position}`} style={style}>
        {children}
      </div>
    </div>
  );
});

export default Popover;
